/* eslint-disable jira/filename-case */

import { getInteractionId } from '@atlaskit/react-ufo/interaction-id-context';
import { getCurrentInteractionType } from '@atlaskit/react-ufo/interaction-metrics';
import { expVal } from '@atlassian/jira-feature-experiments';
import {
	CAPABILITY_LOAD_TYPE,
	type CapabilityLoadType,
	FE_UNATTRIBUTED,
} from '@jira/platform__observability-capabilities/src/constants.tsx';

function inferCapabilityLoadTypeFromInteraction(): CapabilityLoadType {
	const interactionId = getInteractionId().current;
	if (!interactionId) {
		return CAPABILITY_LOAD_TYPE.OTHER;
	}

	const currentInteractionType = getCurrentInteractionType(interactionId);
	if (currentInteractionType === 'page_load') {
		return CAPABILITY_LOAD_TYPE.PAGE_LOAD;
	}
	if (currentInteractionType === 'transition') {
		return CAPABILITY_LOAD_TYPE.TRANSITION;
	}
	return CAPABILITY_LOAD_TYPE.OTHER;
}

function getEnhancedCapabilityHeaderOld(
	capability: string | null | undefined,
): string | null | undefined {
	if (capability == null) {
		return capability;
	}

	const defaultCapabilityHeader = `${capability}--other`;

	const interactionId = getInteractionId().current;
	if (!interactionId) {
		return defaultCapabilityHeader;
	}

	const currentInteractionType = getCurrentInteractionType(interactionId);

	if (currentInteractionType === 'page_load') {
		return `${capability}--page-load`;
	}
	if (currentInteractionType === 'transition') {
		return `${capability}--transition`;
	}
	return defaultCapabilityHeader;
}

function getEnhancedCapabilityHeaderNew(
	capability: string | null | undefined,
	capabilityLoadType?: CapabilityLoadType,
): string {
	const resolvedCapabilityLoadType = __SERVER__
		? CAPABILITY_LOAD_TYPE.SSR
		: (capabilityLoadType ?? inferCapabilityLoadTypeFromInteraction());

	return `${capability ?? FE_UNATTRIBUTED}--${resolvedCapabilityLoadType}`;
}

/**
 * Return capability header value to be passed to `x-atlassian-capability` HTTP header
 * So that backend can attribute metrics to FE experience
 *
 * https://hello.atlassian.net/wiki/spaces/PREE/pages/3968281995/Backend+metrics+-+enhanced+capability+header
 */
export function getEnhancedCapabilityHeader(
	capability: string | null | undefined,
	capabilityLoadType?: CapabilityLoadType,
): string | null | undefined {
	if (expVal('jpo-42550-improve-capability-tracking', 'isEnabled', false)) {
		return getEnhancedCapabilityHeaderNew(capability, capabilityLoadType);
	}

	return getEnhancedCapabilityHeaderOld(capability);
}
